export const response = {
    "results" : {
        "PLOAScore": 76.9,
        "RiskLevel": "Low Alert 2",
        "RiskGroup": "LRL2",
        "TraitTitle": "Good Retention Skills & Overwhelmed",
        "ExplainerVideoUrl": "default_explainer_video.mp3",
        "TraitCopy": "Very good retention can struggle to organise themselves. Can struggle to put in effort at times and purely relies on ‘natural ability’.",
        "PerceptionLevelReadinessEagernessLearn": "Neutral / Negative",
        "PerceptionLevelSelf": "Positive",
        "PerceptionLevelLearning": "Neutral",
        "PerceptionLevelSchool": "Positive",
        "PerceptionLevelTeachers": "Positive",
        "PerceptionLevelEffortDeterminationWork": "Positive",
        "PerceptionLevelResponseSubjectDemands": "Neutral / Negative",
        "ProgressAttainmentPack": false,
        "MentalHealthWelbeingPack": false,
        "PerceptionLevelShowingUpLearn": "Positive",
        "AttitudeBehavioursLearningPack": false,
        "responses": [{
            "id": 8,
            "NoOfTimesViewed": 1,
            "NoOfInteractions": 1,
            "AnsweredDateTime": "2019-05-15T21:53:39.423220Z",
            "TimeSpentOnQuestion": 3.0,
            "AnswerValue": "I am exactly where I would like to be with regards to my day-to-day performance and grades, there is nothing I want to change or improve on",
            "Question": "Where are you now in your academic career & how do you feel towards it?",
            "Group": "Personal Growth",
            "GroupId": 7,
            "Score": 100.0,
            "MaxPossibleScore": 100.0
        }, {
            "id": 9,
            "NoOfTimesViewed": 1,
            "NoOfInteractions": 1,
            "AnsweredDateTime": "2019-05-15T21:53:39.430353Z",
            "TimeSpentOnQuestion": 4.0,
            "AnswerValue": "I try really hard but no matter how much I try I don't get better so I would like this to change",
            "Question": "Out of the following, what would you like to accomplish?",
            "Group": "Personal Growth",
            "GroupId": 7,
            "Score": 50.0,
            "MaxPossibleScore": 200.0
        }, {
            "id": 10,
            "NoOfTimesViewed": 1,
            "NoOfInteractions": 1,
            "AnsweredDateTime": "2019-05-15T21:53:39.436351Z",
            "TimeSpentOnQuestion": 2.0,
            "AnswerValue": "I am extremely organised; I hate not being organised.  I plan everything the night before and ensure my homework is always completed and handed in ahead of schedule",
            "Question": "Tell me about how organised you are ",
            "Group": "Time management",
            "GroupId": 1,
            "Score": 100.0,
            "MaxPossibleScore": 300.0
        }, {
            "id": 11,
            "NoOfTimesViewed": 1,
            "NoOfInteractions": 1,
            "AnsweredDateTime": "2019-05-15T21:53:39.442304Z",
            "TimeSpentOnQuestion": 3.0,
            "AnswerValue": "I am better at remembering facts, formula and figures but not that good at remembering large pieces of text and chunks of information",
            "Question": "Tell me about your memory",
            "Group": "Retention & Recollection",
            "GroupId": 6,
            "Score": 100.0,
            "MaxPossibleScore": 400.0
        }, {
            "id": 12,
            "NoOfTimesViewed": 1,
            "NoOfInteractions": 1,
            "AnsweredDateTime": "2019-05-15T21:53:39.448309Z",
            "TimeSpentOnQuestion": 5.0,
            "AnswerValue": "5-7 (I am ok, somewhere in the middle between no energy and lots of energy)",
            "Question": "On a scale of 1-10, 10 being so much energy and 1 being none at all how do you feel mostly at school?",
            "Group": "Your lifestyle",
            "GroupId": 5,
            "Score": 50.0,
            "MaxPossibleScore": 500.0
        }, {
            "id": 13,
            "NoOfTimesViewed": 1,
            "NoOfInteractions": 1,
            "AnsweredDateTime": "2019-05-15T21:53:39.454518Z",
            "TimeSpentOnQuestion": 5.0,
            "AnswerValue": "4",
            "Question": "Give yourself a score out of 5,5 being amazing and 1 being poor at writing",
            "Group": "Your classwork",
            "GroupId": 2,
            "Score": 50.0,
            "MaxPossibleScore": 575.0
        }, {
            "id": 14,
            "NoOfTimesViewed": 1,
            "NoOfInteractions": 1,
            "AnsweredDateTime": "2019-05-15T21:53:39.460576Z",
            "TimeSpentOnQuestion": 14.0,
            "AnswerValue": "Make reading a lot easier than it is now",
            "Question": "Out of the following, what would you like to achieve the most this year in class (you can only pick one so think carefully)?",
            "Group": "Your goals",
            "GroupId": 4,
            "Score": 50.0,
            "MaxPossibleScore": 650.0
        }]
    },
    "assessment_info": {
        "isPreAssessment": true,
        "TargetGroup": "students",
        "Title": "Welcome to PLEX"
    }
}


export const breakdownResponse = {
    "breakdown": {
        "completed": 2,
        "incomplete": 3,
        "assessments": [
            {
                "id": "1",
                "Creator": "admin",
                "Title": "Welcome To PLEX",
                "Version": 0.5,
                "Preassess": true,
                "TargetGroup": "students",
                "Level": "PLOA_PRIMARY",
                "Enabled": true,
                "Created": "12, Sep 2018",
                "UpdatedDateTime": "2018-09-12T07:00:00Z"
            },
            {
                "id": "2",
                "Creator": "admin",
                "Title": "Welcome To PLEX",
                "Version": 0.5,
                "Preassess": true,
                "TargetGroup": "students",
                "Level": "PLOA_SECONDARY",
                "Enabled": false,
                "Created": "12, Sep 2018",
                "UpdatedDateTime": "2019-06-20T19:41:51.106568Z"
            }
        ]
    }
}




// WEBPACK FOOTER //
// ./src/assets/data/sampleResults.ts